module.exports = __webpack_public_path__ + "static/media/jatiuca-capa.65edf515.png";